var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleSwitchedFuseSpurAtHighLevelForExtractFan01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.15;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.15;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.2,8.1h4.1c0-2.4-1.9-4.3-4.3-4.3c0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3.2,
    y1: 8.1,
    x2: 13,
    y2: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3,8.1h4.3c0.2,2.2-1.4,4-3.6,4.2c-0.2,0-0.5,0-0.7,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleSwitchedFuseSpurAtHighLevelForExtractFan01);
export default __webpack_public_path__ + "static/media/SingleSwitchedFuseSpurAtHighLevelForExtractFan-01.f8f2937e0bfb0eb2279625899d7c0c1f.svg";
export { ForwardRef as ReactComponent };